import axiosInstance from "../../../common/axios/axsiosInstance";
// import { AuthApiEnum } from "./consts";

export async function singInRequest(userData, setErrorModalShow) {
  try {
    const response = await axiosInstance.post(
      `auth/register`,
      userData
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      setErrorModalShow({
        message: error.response.data?.message,
      });
    }
    console.error(error);
  }
}

export async function singnOutRequest() {
  try {
    const response = await axiosInstance.delete("auth/signout");

    if (response.status === 204) {
      return "ok";
    }
  } catch (error) {
    console.error(error);
  }
}

export async function singInByGoogle(userData) {
  try {
    const response = await axiosInstance.post(`auth/google`, userData);

    if (response.status === 200) {
      return response.data.token;
    }
  } catch (error) {
    console.error(error);
  }
}

export async function getUserInfo(setErrorModalShow) {
  try {
    const response = await axiosInstance.get("auth/me");

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.data?.status === 404) {
      const errorMessage = getErrorMessage(error);
      setErrorModalShow({
        message: errorMessage,
      });
    }
    console.error(error);
  }
}
const getErrorMessage = (error) => {
  if (error.response) {
    const status = error.response.status;
    const serverMessage = error.response.data?.message;

    const statusMessages = {
      400: "Please check your input and try again",
      401: "Please log in again",
      403: "You don't have permission for this",
      409: "This already exists",
      422: "Please check your input",
      429: "Too many requests, please wait",
      500: "Server error, please try again",
    };

    return serverMessage || statusMessages[status] || "Something went wrong";
  }

  if (error.request) {
    return "Network error, please check your connection";
  }
  return "An unexpected error occurred";
};

//  toDo avelacnel bolor api-nerum

// toDo avelacnel loderner api colly jamanak

// stugel baiqic ekox infon

// toDo poxel validacian heraxosi hamar ev bolor validacianery
